import { FC, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
// @ts-ignore
import { NotificationManager } from 'react-notifications';

import { setUserInfoData, getUserInfo, updateUserInfo, clearUserError } from 'modules/user/actions';
import { dispatch } from 'store';
import { Input, Button, LanguagesSelect } from 'views/components';
import { RootState } from 'types';

import logo from 'assets/images/logo.svg';
import styles from './Profile.module.css';
import { setNotification } from 'modules/app/actions';
import texts from './texts';
import { t } from 'utils';

export const Profile: FC = () => {
  const { userInfo, errors, loading } = useSelector((state: RootState) => state.user);
  const { notification } = useSelector((state: RootState) => state.app);
  const [validEmail, setValidEmail] = useState(true);

  const handleInputChange = (event: any) => {
    const {
      name,
      value,
      validity: { valid },
    } = event.target;
    if (name === 'email') {
      dispatch(setUserInfoData(name, value));
      if (valid) {
        setValidEmail(true);
      } else {
        setValidEmail(false);
      }
    } else if (valid) {
      dispatch(setUserInfoData(name, value));
    }
  };

  const { fullName, email, phoneNumber, clinicName, yourPosition } = userInfo;

  const disabled =
    !fullName || !email || !phoneNumber || !clinicName || !yourPosition || !validEmail;

  useEffect(() => {
    dispatch(clearUserError());
    dispatch(getUserInfo.request());
  }, []);

  useEffect(() => {
    if (notification.status && notification.type === 'success') {
      NotificationManager.success(notification.text);
      dispatch(setNotification(false));
    }
  }, [notification]);

  return (
    <div className={styles.wrap}>
      <div className={styles.top}>
        <Link to="/dashboard">
          <img className={styles.logo} src={logo} alt="Logo" />
        </Link>
        <LanguagesSelect />
      </div>
      <div>
        <Link className={styles.link} to="/dashboard">
          {t(texts.profile.backToDashboard)}
        </Link>
      </div>
      <h1 style={{ fontSize: 40, fontWeight: 'bold', lineHeight: '50px' }}>
        {t(texts.profile.title)}
      </h1>

      <Input
        name="clinicName"
        value={clinicName}
        onChange={(e: any) => handleInputChange(e)}
        label={t(texts.profile.clinicName)}
        error={errors.clinicName}
        maxLength={64}
      />
      <Input
        name="yourPosition"
        value={yourPosition}
        onChange={(e: any) => handleInputChange(e)}
        label={t(texts.profile.yourPosition)}
        error={errors.positionTitle}
        maxLength={64}
      />
      <div className={styles.items}>
        <div className={styles.item}>
          <Input
            name="fullName"
            value={fullName}
            onChange={(e: any) => handleInputChange(e)}
            label={t(texts.profile.yourFullName)}
            error={errors.fullName}
            pattern="[a-zA-Z\s]+"
            maxLength={128}
          />
        </div>
        <div className={styles.item}>
          <Input
            name="phoneNumber"
            value={phoneNumber}
            onChange={(e: any) => handleInputChange(e)}
            label={t(texts.profile.phoneNumber)}
            error={errors.phoneNumber}
            pattern="[0-9]*"
            maxLength={16}
          />
        </div>
      </div>
      <Input
        name="email"
        error={errors.email}
        value={email}
        onChange={(e: any) => handleInputChange(e)}
        label={t(texts.profile.email)}
        pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
        maxLength={128}
      />
      <div style={{ marginTop: '40px' }}>
        <Button
          disabled={disabled}
          title={t(texts.profile.saveChanges)}
          onClick={() => dispatch(updateUserInfo.request())}
          loading={loading}
        />
      </div>
    </div>
  );
};
